module.exports = __webpack_public_path__ + "static/media/twitter.642901af.svg";